/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import { ManageScheduleModal_CustomerFragmentDoc } from '../../../__generated__/ManageScheduleModal.graphql';
import { ManageScheduleModal_DisplayFragmentDoc } from '../../../__generated__/ManageScheduleModal.graphql';
import { ScheduleTimeline_DisplayFragmentDoc } from './ScheduleTimeline.graphql';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type ScheduleCard_CustomerFragment = { __typename: 'Customer', id: string, schedules: Array<{ __typename: 'Schedule', id: string, title: string, timeBlocks: Array<{ __typename: 'ScheduleTimeBlock', type: Types.TimeBlockType, data: { __typename: 'ScheduleTimeBlockData', mediaType?: string | null } }> }> };

export type ScheduleCard_DisplayFragment = { __typename: 'Display', id: string, playlistType?: Types.PlaylistType | null, schedule?: { __typename: 'DisplaySchedule', isSynced?: boolean | null, latestJob?: { __typename: 'ScheduleUpdateAborted', id: string } | { __typename: 'ScheduleUpdateCompleted', id: string } | { __typename: 'ScheduleUpdateInProgress', id: string } | { __typename: 'ScheduleUpdateRejected', id: string } | null, schedule?: { __typename: 'Schedule', title: string, id: string, timeBlocks: Array<{ __typename: 'ScheduleTimeBlock', start: string, end: string, day: Types.Day, type: Types.TimeBlockType, priority: number, category: Types.TimeBlockCategory, data: { __typename: 'ScheduleTimeBlockData', id?: string | null, title?: string | null, mediaType?: string | null, applicationId?: string | null, source?: string | null, url?: string | null, value?: number | null } }> } | null, slotWarnings: Array<{ __typename: 'ScheduleSlotWarning', slotIndex: number, warning: Types.ScheduleSlotWarningSeverity }> } | null, timeZone?: { __typename: 'TimeZoneState', reported: string, desired?: string | null } | null };

export type DisplayClearScheduleMutationVariables = Types.Exact<{
  displayId: Types.Scalars['ID'];
}>;


export type DisplayClearScheduleMutation = { __typename: 'Mutation', displayBulkUpdateSchedule: { __typename: 'DisplayBulkUpdateSchedulePayload', displays: Array<{ __typename: 'Display', id: string, playlistType?: Types.PlaylistType | null, schedule?: { __typename: 'DisplaySchedule', isSynced?: boolean | null, latestJob?: { __typename: 'ScheduleUpdateAborted', id: string } | { __typename: 'ScheduleUpdateCompleted', id: string } | { __typename: 'ScheduleUpdateInProgress', id: string } | { __typename: 'ScheduleUpdateRejected', id: string } | null, schedule?: { __typename: 'Schedule', title: string, id: string, timeBlocks: Array<{ __typename: 'ScheduleTimeBlock', start: string, end: string, day: Types.Day, type: Types.TimeBlockType, priority: number, category: Types.TimeBlockCategory, data: { __typename: 'ScheduleTimeBlockData', id?: string | null, title?: string | null, mediaType?: string | null, applicationId?: string | null, source?: string | null, url?: string | null, value?: number | null } }> } | null, slotWarnings: Array<{ __typename: 'ScheduleSlotWarning', slotIndex: number, warning: Types.ScheduleSlotWarningSeverity }> } | null, timeZone?: { __typename: 'TimeZoneState', reported: string, desired?: string | null } | null }> } };

export type DisplaySyncScheduleMutationVariables = Types.Exact<{
  displayId: Types.Scalars['ID'];
  scheduleId: Types.Scalars['ID'];
}>;


export type DisplaySyncScheduleMutation = { __typename: 'Mutation', displayBulkUpdateSchedule: { __typename: 'DisplayBulkUpdateSchedulePayload', displays: Array<{ __typename: 'Display', id: string, playlistType?: Types.PlaylistType | null, schedule?: { __typename: 'DisplaySchedule', isSynced?: boolean | null, latestJob?: { __typename: 'ScheduleUpdateAborted', id: string } | { __typename: 'ScheduleUpdateCompleted', id: string } | { __typename: 'ScheduleUpdateInProgress', id: string } | { __typename: 'ScheduleUpdateRejected', id: string } | null, schedule?: { __typename: 'Schedule', title: string, id: string, timeBlocks: Array<{ __typename: 'ScheduleTimeBlock', start: string, end: string, day: Types.Day, type: Types.TimeBlockType, priority: number, category: Types.TimeBlockCategory, data: { __typename: 'ScheduleTimeBlockData', id?: string | null, title?: string | null, mediaType?: string | null, applicationId?: string | null, source?: string | null, url?: string | null, value?: number | null } }> } | null, slotWarnings: Array<{ __typename: 'ScheduleSlotWarning', slotIndex: number, warning: Types.ScheduleSlotWarningSeverity }> } | null, timeZone?: { __typename: 'TimeZoneState', reported: string, desired?: string | null } | null }> } };

export const ScheduleCard_CustomerFragmentDoc = gql`
    fragment ScheduleCard_customer on Customer {
  id
  ...ManageScheduleModal_customer
}
    ${ManageScheduleModal_CustomerFragmentDoc}`;
export const ScheduleCard_DisplayFragmentDoc = gql`
    fragment ScheduleCard_display on Display {
  id
  ...ManageScheduleModal_display
  ...ScheduleTimeline_display
  schedule {
    isSynced
    latestJob {
      __typename
    }
    schedule {
      title
    }
  }
}
    ${ManageScheduleModal_DisplayFragmentDoc}
${ScheduleTimeline_DisplayFragmentDoc}`;
export const DisplayClearScheduleDocument = gql`
    mutation DisplayClearSchedule($displayId: ID!) {
  displayBulkUpdateSchedule(input: {displayIds: [$displayId], scheduleId: null}) {
    displays {
      id
      ...ScheduleCard_display
    }
  }
}
    ${ScheduleCard_DisplayFragmentDoc}`;
export type DisplayClearScheduleMutationFn = ApolloReactCommon.MutationFunction<DisplayClearScheduleMutation, DisplayClearScheduleMutationVariables>;

/**
 * __useDisplayClearScheduleMutation__
 *
 * To run a mutation, you first call `useDisplayClearScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisplayClearScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [displayClearScheduleMutation, { data, loading, error }] = useDisplayClearScheduleMutation({
 *   variables: {
 *      displayId: // value for 'displayId'
 *   },
 * });
 */
export function useDisplayClearScheduleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DisplayClearScheduleMutation, DisplayClearScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DisplayClearScheduleMutation, DisplayClearScheduleMutationVariables>(DisplayClearScheduleDocument, options);
      }
export type DisplayClearScheduleMutationHookResult = ReturnType<typeof useDisplayClearScheduleMutation>;
export type DisplayClearScheduleMutationResult = ApolloReactCommon.MutationResult<DisplayClearScheduleMutation>;
export type DisplayClearScheduleMutationOptions = ApolloReactCommon.BaseMutationOptions<DisplayClearScheduleMutation, DisplayClearScheduleMutationVariables>;
export const DisplaySyncScheduleDocument = gql`
    mutation DisplaySyncSchedule($displayId: ID!, $scheduleId: ID!) {
  displayBulkUpdateSchedule(
    input: {displayIds: [$displayId], scheduleId: $scheduleId}
  ) {
    displays {
      id
      ...ScheduleCard_display
    }
  }
}
    ${ScheduleCard_DisplayFragmentDoc}`;
export type DisplaySyncScheduleMutationFn = ApolloReactCommon.MutationFunction<DisplaySyncScheduleMutation, DisplaySyncScheduleMutationVariables>;

/**
 * __useDisplaySyncScheduleMutation__
 *
 * To run a mutation, you first call `useDisplaySyncScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisplaySyncScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [displaySyncScheduleMutation, { data, loading, error }] = useDisplaySyncScheduleMutation({
 *   variables: {
 *      displayId: // value for 'displayId'
 *      scheduleId: // value for 'scheduleId'
 *   },
 * });
 */
export function useDisplaySyncScheduleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DisplaySyncScheduleMutation, DisplaySyncScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DisplaySyncScheduleMutation, DisplaySyncScheduleMutationVariables>(DisplaySyncScheduleDocument, options);
      }
export type DisplaySyncScheduleMutationHookResult = ReturnType<typeof useDisplaySyncScheduleMutation>;
export type DisplaySyncScheduleMutationResult = ApolloReactCommon.MutationResult<DisplaySyncScheduleMutation>;
export type DisplaySyncScheduleMutationOptions = ApolloReactCommon.BaseMutationOptions<DisplaySyncScheduleMutation, DisplaySyncScheduleMutationVariables>;